import React, { useEffect, useState } from 'react'
import { SvgImages } from '../../Utils/LocalImages';
import Image from '../../Components/Reusable/Image';
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import RoutesPath from '../../Utils/RoutesPath';
import CustomTextField from '../../Components/Reusable/CustomTextField';
import { handleApiErrors, InputType, validationRegex } from '../../Utils/Utils';
import * as Yup from "yup";
import { set, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomDropDown from '../../Components/Reusable/CustomDropDown';
import DataProvider from '../../Utils/DataProvider';
import ClassService from '../../Services/ClassService';
import ButtonWithIcon from '../../Components/Reusable/ButtonWithIcon';
import StateService from '../../Services/StateService';
import DistrictService from '../../Services/DistrictService';
import PincodeService from '../../Services/PincodeService';
import TalukaService from '../../Services/TalukaService';
import BharatSatService from '../../Services/BharatSatService';
import { toast } from 'react-toastify';

const StudentDetailsEdit = () => {
    // const [details, setDetails] = useState(null);
    const [classes, setClasses] = useState([]);
    // const location = useLocation();
    const [states, setStates] = useState([]);
    const navigate = useNavigate();
    const [studentEdit, setStudentEdit] = useState({ ...useLocation().state });
    const [showDistrict, setShowDistrict] = useState(true);
    const [showTaluka, setShowTaluka] = useState(true);
    const [showPinCode, setShowPinCode] = useState(true);
    const [districts, setDistricts] = useState([]);
    const [talukas, setTalukas] = useState([]);
    const [pincodes, setPincodes] = useState([]);
    const [resetDistrict, setResetDistrict] = useState(false);
    const [resetTaluka, setResetTaluka] = useState(false);
    const [resetPinCode, setResetPinCode] = useState(false);


    // useEffect(() => {
    //     if (location.state && location.state.details) {
    //         setDetails(location.state.details);
    //     }
    // }, [location]);


    const Validations = Yup.object().shape({
        firstName: validationRegex.required,
        middleName: validationRegex.required,
        lastName: validationRegex.required,
        dateOfBirth: validationRegex.dob,
        gender: validationRegex.required,
        schoolName: validationRegex.required,
        medium: validationRegex.required,
        classId: validationRegex.required,
        email: validationRegex.email,
        mobile: validationRegex.mobile,
        addressLineOne: validationRegex.required,
        addressLineTwo: validationRegex.required,
        state: validationRegex.required,
        district: showDistrict ? validationRegex.required : Yup.mixed().nullable(),
        taluka: showTaluka ? validationRegex.required : Yup.mixed().nullable(),
        pinCode: showPinCode ? validationRegex.required : Yup.mixed().nullable(),
    });
    const {
        register: register,
        handleSubmit: handleSubmit,
        setValue: setValues,
        formState: { errors: errors },
        getValues: getValues,
        reset: reset,
        watch: watchdetails,
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            firstName: studentEdit?.firstName || studentEdit?.userName || "",
            middleName: studentEdit?.middleName || "",
            lastName: studentEdit?.lastName || "",
            dateOfBirth: studentEdit?.dateOfBirth || "",
            gender: studentEdit?.gender || "",
            schoolName: studentEdit?.schoolName || "",
            medium: studentEdit?.medium || "",
            classId: studentEdit?.classId || "",
            email: studentEdit?.email || "",
            mobile: studentEdit?.mobile || "",
            addressLineOne: studentEdit?.addressLineOne || "",
            addressLineTwo: studentEdit?.addressLineTwo || "",
            state: studentEdit?.state || "",
            taluka: studentEdit?.taluka || "",
            district: studentEdit?.district || "",
            pinCode: studentEdit?.pinCode || "",
        },
    });

    const editStudentDetails = async (studentData) => {
        console.log(studentData, "rgjhrjk")
        const cleanedData = {
            ...studentData,
            district: showDistrict ? studentData.district : null,
            taluka: showTaluka ? studentData.taluka : null,
            pinCode: showPinCode ? studentData.pinCode : null,
        };
        try {
            // Call BlogService to add the blog
            const response = await BharatSatService.editStudentDetails(
                studentEdit.user_id || studentEdit.userId || "",
                cleanedData.firstName,
                cleanedData.middleName,
                cleanedData.lastName,
                cleanedData.dateOfBirth,
                cleanedData.gender,
                cleanedData.schoolName,
                cleanedData.classId,
                cleanedData.medium,
                cleanedData.email,
                cleanedData.mobile,
                cleanedData.addressLineOne,
                cleanedData.addressLineTwo,
                cleanedData.state,
                cleanedData.district,
                cleanedData.taluka,
                cleanedData.pinCode,
            );
            toast.success(response.message);
            navigate(RoutesPath.registrationPageListing);
            setStudentEdit({})
        } catch (error) {
            // Handle API errors
            handleApiErrors(error);
            toast.error("Failed to update student details. Please try again later.");
        }
    };




    const removeTimeFromDate = (dateString) => {
        if (!dateString) return '';
        const dateObject = new Date(dateString);
        // Ensure the date is parsed as UTC
        const utcYear = dateObject.getUTCFullYear();
        const utcMonth = dateObject.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
        const utcDay = dateObject.getUTCDate();
        return `${utcDay} ${utcMonth} , ${utcYear}`;

    };
    const getAllClasses = async () => {
        try {
            const response = await ClassService.getAllClassesWithoutPagination();
            setClasses(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };
    const getAllStates = async () => {
        try {
            const response = await StateService.getAll();
            setStates(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };
    const getAllDistrict = async (state_id) => {
        try {
            const response = await DistrictService.getAll(state_id);
            setShowDistrict(response.data.length > 0);
            setShowPinCode(response.data.length > 0);
            setShowTaluka(response.data.length > 0);
            setDistricts(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllPincodes = async (taluka_id) => {
        try {
            const response = await PincodeService.getAll(taluka_id);
            setShowPinCode(response.data.length > 0);
            setPincodes(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllTalukas = async (district_id) => {
        try {
            const response = await TalukaService.getAll(district_id);
            setShowPinCode(response.data.length > 0);
            setShowTaluka(response.data.length > 0);
            setTalukas(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    useEffect(() => {
        getAllClasses()
        getAllStates()
        setShowDistrict(!!studentEdit.district); // Show if district exists
        setShowTaluka(!!studentEdit.taluka); // Show if taluka exists
        setShowPinCode(!!studentEdit.pinCode); // Show if pinCode exists
    }, [studentEdit])


    // useEffect(() => {
    //     // setResetTaluka(true);
    //     // setResetPinCode(true);
    //     if (
    //       watchdetails("district") &&
    //       watchdetails("district") != ""
    //     )
    //       getAllTalukas(watchdetails("district"));
    //   }, [watchdetails("district")]);

    //   useEffect(() => {
    //     // setResetDistrict(true);
    //     // setResetTaluka(true);
    //     // setResetPinCode(true);
    //     if (watchdetails("state") && watchdetails("state") != "")
    //         getAllDistrict(watchdetails("state"));
    //   }, [watchdetails("state")]);

    //   useEffect(() => {
    //     // setResetPinCode(true);
    //     if (watchdetails("taluka") && watchdetails("taluka") != "")
    //       getAllPincodes(watchdetails("taluka"));
    //   }, [watchdetails("taluka")]);

    //     useEffect(() => {
    // setResetDistrict(true);
    //         setResetTaluka(true);
    //         setResetPinCode(true);
    //     },[])

    useEffect(() => {
        if (studentEdit) {
            const formattedDate =
                studentEdit?.dateOfBirth instanceof Date
                    ? studentEdit.dateOfBirth.toLocaleDateString("en-CA").split('T')[0]
                    : (studentEdit?.dateOfBirth
                        ? new Date(studentEdit?.dateOfBirth.split("/").reverse().join("-")).toLocaleDateString("en-CA").split('T')[0]
                        : ""
                    );

            setValues("dateOfBirth", formattedDate);
        }
    }, [studentEdit, setValues]);

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <h1 className="black fs-18 fw-600 mb-0 text-uppercase">
                    {" "}
                    Student Details
                </h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">
                        {" "}
                        Registration Page Listing
                    </h4>
                </div>
            </div>

            <div className="table_container">
                <h1 className="black fs-18 fw-600 mb-0">Edit Student Details</h1>
                <div className=" fs-16 fw-600 mt-3 mb-3 blue">Personal Details</div>
                {/* <form className="" onSubmit={handleSubmitStepOne(saveStepOneData)}> */}
                <form onSubmit={handleSubmit(editStudentDetails)}>
                    <div className="row profile_inputs w-100">
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="First Name"
                                placeholder="Enter First Name"
                                name="firstName"
                                id="firstName"
                                showError={errors?.firstName}
                                errorMessage={errors?.firstName?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Middle Name"
                                placeholder="Enter Middle Name"
                                name="middleName"
                                id="middleName"
                                showError={errors?.middleName}
                                errorMessage={errors?.middleName?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Last Name"
                                placeholder="Enter Last Name"
                                name="lastName"
                                id="lastName"
                                showError={errors?.lastName}
                                errorMessage={errors?.lastName?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Date of Birth"
                                placeholder="Enter Date Of Birth"
                                name="dateOfBirth"
                                id="dateOfBirth"
                                showError={errors?.dateOfBirth}
                                errorMessage={errors?.dateOfBirth?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                inputType="date"
                                showMandatory={true}
                            // defaultOption={() => {
                            //     return studentEdit.dateOfBirth ? { value: studentEdit.dateOfBirth, label: studentEdit.dateOfBirth } : null
                            //   }}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomDropDown
                                labelTitle="Gender"
                                id="gender"
                                name="gender"
                                placeholder="Select Gender"
                                showError={errors?.gender}
                                errorMessage={errors?.gender?.message}
                                register={register}
                                setValue={setValues}
                                additionalClasses="profile_edit"
                                options={DataProvider.Genders}
                                defaultOption={() => {
                                    return studentEdit.gender
                                        ? { value: studentEdit.gender, label: studentEdit.gender }
                                        : null;
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="School Name"
                                placeholder="Enter School Name"
                                name="schoolName"
                                id="schoolName"
                                showError={errors?.schoolName}
                                errorMessage={errors?.schoolName?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomDropDown
                                labelTitle="Select Medium"
                                placeholder="Select"
                                name="medium"
                                id="medium"
                                additionalClasses="profile_edit"
                                // setResetValue={setResetMedium}
                                // resetValue={resetMedium}
                                inputType={InputType.text}
                                showError={errors?.medium}
                                errorMessage={errors?.medium?.message}
                                showMandatory={true}
                                setValue={setValues}
                                options={DataProvider.mediumList}
                                defaultOption={() => {
                                    return studentEdit.medium
                                        ? { value: studentEdit.medium, label: studentEdit.medium }
                                        : null;
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            {classes && classes.length != 0 && (
                                <CustomDropDown
                                    labelTitle="Select Class"
                                    placeholder="Select"
                                    name="classId"
                                    id="classId"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    showError={errors?.classId}
                                    errorMessage={errors?.classId?.message}
                                    showMandatory={true}
                                    setValue={setValues}
                                    options={classes?.map((e) => {
                                        return { value: e._id, label: e.class_name };
                                    })}
                                    defaultOption={() => {
                                        if (studentEdit?.classId && classes) {
                                            const matchingClass = classes.find(
                                                (value) => value._id === studentEdit.classId
                                            );
                                            if (matchingClass) {
                                                return {
                                                    value: matchingClass._id,
                                                    label: matchingClass.class_name,
                                                };
                                            }
                                        }
                                        return null;
                                    }}
                                />
                            )}
                        </div>

                    </div>
                    <div className="row profile_inputs w-100">
                        <div className=" fs-16 fw-600 mt-3 mb-3 blue">Contact Details</div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Email"
                                id="email"
                                name="email"
                                inputType={InputType.text}
                                placeholder="Enter your email id"
                                showError={errors?.email}
                                errorMessage={errors?.email?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}

                            />
                        </div>

                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Mobile"
                                id="mobile"
                                name="mobile"
                                inputType={InputType.number}
                                placeholder="Enter your mobile no."
                                showError={errors?.mobile}
                                errorMessage={errors?.mobile?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Address Line-1"
                                placeholder="Enter Address Line-1"
                                name="addressLineOne"
                                id="addressLineOne"
                                showError={errors?.addressLineOne}
                                errorMessage={errors?.addressLineOne?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Address Line-2"
                                placeholder="Enter Address Line-2"
                                name="addressLineTwo"
                                id="addressLineTwo"
                                showError={errors?.addressLineTwo}
                                errorMessage={errors?.addressLineTwo?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomDropDown
                                labelTitle="State"
                                id="state"
                                name="state"
                                placeholder="Select State"
                                showError={errors?.state}
                                errorMessage={errors?.state?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                setValue={setValues}
                                onChange={(e) => {
                                    getAllDistrict(e.value)
                                    setResetDistrict(true)
                                    setResetTaluka(true)
                                    setResetPinCode(true)
                                }}

                                showMandatory={true}
                                options={states.map((e) => {
                                    return { value: e._id, label: e.name };
                                })}
                                defaultOption={() => {
                                    return studentEdit.state ? { value: studentEdit.state, label: studentEdit.state } : null
                                }}
                            />
                        </div>
                        {showDistrict ? (
                            <div className="col-md-6">
                                <CustomDropDown
                                    labelTitle="District"
                                    id="district"
                                    name="district"
                                    placeholder="Select District"
                                    showError={errors?.district}
                                    errorMessage={errors?.district?.message}
                                    register={register}
                                    setValue={setValues}
                                    showMandatory={true}
                                    additionalClasses="profile_edit"
                                    onChange={(e) => {
                                        getAllTalukas(e.value)

                                    }}
                                    resetValue={resetDistrict}
                                    setResetValue={setResetDistrict}
                                    options={districts.map((e) => {
                                        return { value: e._id, label: e.name };
                                    })}
                                    defaultOption={() => {
                                        return studentEdit.district ? { value: studentEdit.district, label: studentEdit.district } : null
                                    }}
                                />
                            </div>
                        ) : null}

                        {showTaluka ? (
                            <div className="col-md-6">
                                <CustomDropDown
                                    labelTitle="Taluka"
                                    id="taluka"
                                    name="taluka"
                                    placeholder="Select Taluka"
                                    showError={errors?.taluka}
                                    errorMessage={errors?.taluka?.message}
                                    register={register}
                                    setValue={setValues}
                                    showMandatory={true}
                                    additionalClasses="profile_edit"
                                    onChange={(e) => {
                                        getAllPincodes(e.value)

                                    }}
                                    resetValue={resetTaluka}
                                    setResetValue={setResetTaluka}
                                    options={talukas.map((e) => {
                                        return { value: e._id, label: e.name };
                                    })}
                                    defaultOption={() => {
                                        return studentEdit.taluka ? { value: studentEdit.taluka, label: studentEdit.taluka } : null
                                    }}
                                />
                            </div>
                        ) : null}

                        {showPinCode ? (
                            <div className="col-md-6">
                                <CustomDropDown
                                    labelTitle="Pin Code"
                                    id="pinCode"
                                    name="pinCode"
                                    placeholder="Select Pin Code"
                                    showError={errors?.pinCode}
                                    errorMessage={errors?.pinCode?.message}
                                    register={register}
                                    setValue={setValues}
                                    showMandatory={true}
                                    additionalClasses="profile_edit"
                                    resetValue={resetPinCode}
                                    setResetValue={setResetPinCode}
                                    onClick={getAllPincodes}
                                    options={pincodes.map((e) => {
                                        return { value: e._id, label: e.name };
                                    })}
                                    defaultOption={() => {
                                        return studentEdit.pinCode ? { value: studentEdit.pinCode, label: studentEdit.pinCode } : null
                                    }}
                                />
                            </div>
                        ) : null}
                        {/* <div className="col-md-6">
                            <CustomTextField
                                labelTitle="District"
                                placeholder="Enter District Name"
                                name="district"
                                id="district"
                                showError={errors?.district}
                                errorMessage={errors?.district?.message}
                                register={register}
                                additionalClasses="profile_edit"
                                showMandatory={true}
                            />
                        </div>
                        <div className="col-md-6">
                            <CustomTextField
                                labelTitle="Pin Code"
                                id="pinCode"
                                name="pinCode"
                                inputType={InputType.number}
                                placeholder="Select Pin Code"
                                showError={errors?.pinCode}
                                errorMessage={errors?.pinCode?.message}
                                register={register}
                                setValue={setValues}
                                showMandatory={true}
                                additionalClasses="profile_edit"
                            />
                        </div> */}
                    </div>


                </form>
                <div className="d-flex justify-content-end mt-5">
                    <ButtonWithIcon
                        text={studentEdit.user_id || studentEdit.userId ? "Update" : "Submit"}
                        icon={SvgImages.tick_mark}
                        onClick={handleSubmit(editStudentDetails)}
                    />
                </div>
            </div>
        </div>
    )
}

export default StudentDetailsEdit




